import { useState } from 'react';
import { useNavigate } from "react-router";
import { DashCircleFill, PlusCircleFill } from 'react-bootstrap-icons';

import classes from './styles/FoodItem.module.css';
import Price from '../../UI/Price';

const FoodItem = ({ name, description, price, id,  promoId = null, defaultQty = 1, showQtySelector = true }) => {
  let navigate = useNavigate();
  const [qty, setQty] = useState(defaultQty);

  const handleMinusQty = () => {
    if(qty > 1)
      setQty(prevState => prevState - 1);
  }
  
  const handlePlusQty = () => {
    if(qty < 10)
      setQty(prevState => prevState + 1);
  }

  const handleClick = () => {
    if( promoId )
      navigate(`/product/${id}/${qty * 2}/${promoId}`);
    else
      navigate(`/product/${id}/${qty}`);
  }
  
  return (
    <li className={classes.food}>
      <div onClick={handleClick} className='w-100 pe-2'>
        <h3>{name}</h3>
        <div className={classes.description}>{description}</div>
        <div className={classes.price}>
          <Price value={price} />
        </div>
      </div>
      <div className='d-flex flex-column'>

        <div style={{
          borderRadius: '14px',
          border: '1px solid #c1c1c1',
          width: '90px',
          height: '90px',
          overflow: 'hidden'
          }}>
          <img 
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            onClick={handleClick} 
            src={`${window.runtimeConfig.API_URL}/public/shop/${window.runtimeConfig.SHOP_ID}/images/product/${id}`} 
            />
        </div>

        {showQtySelector && (
          <div className='d-flex justify-content-center align-items-center text-center mt-1' style={{ fontSize: '22px' }}>
            <DashCircleFill className={classes.qtyButton} onClick={handleMinusQty} />
            <span className='px-1'>{qty}</span>
            <PlusCircleFill className={classes.qtyButton} onClick={handlePlusQty} />
          </div>
        )}
      </div>
    </li>
  );
};

export default FoodItem;
